var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sop" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _vm.roleObj.KHSOPhfsop
            ? _c(
                "el-tab-pane",
                { attrs: { label: "回访SOP", name: "first" } },
                [_c("ReturnVisitSOPList")],
                1
              )
            : _vm._e(),
          _vm.roleObj.KHSOPxzhysop
            ? _c(
                "el-tab-pane",
                { attrs: { label: "新增好友SOP", name: "second" } },
                [_c("NewFriendsSOPList")],
                1
              )
            : _vm._e(),
          _vm.roleObj.KHSOPpyqsop
            ? _c(
                "el-tab-pane",
                { attrs: { label: "朋友圈SOP", name: "third" } },
                [_c("WechatMomentsSOPList")],
                1
              )
            : _vm._e(),
          _vm.roleObj.KHSOPsrtxsop
            ? _c(
                "el-tab-pane",
                { attrs: { label: "生日提醒SOP", name: "fourth" } },
                [_c("BirthdayReminderList")],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }